import { gql } from "@apollo/client";

const GET_GESTION_ASISTENCIAL_UBICACION = gql`
    query UbicacionAsistencial(
            $idEvaluacion: Int!
            $codPaciente: String!
        ) {
        pacienteSAP(
            idEvaluacion: $idEvaluacion
            codPaciente: $codPaciente
        ) {
            domicilio
            provincia
            cP
            localidad
            provincia
            observacionExtra
        }
    }
`;

export default GET_GESTION_ASISTENCIAL_UBICACION;

export const adaptUbicacion = (pacienteSAP) => {
  return {
    direccion: pacienteSAP?.domicilio,
    provincia: pacienteSAP?.provincia,
    codigoPostal: pacienteSAP?.cP,
    localidad: pacienteSAP?.localidad,
    observacion: pacienteSAP?.observacionExtra
  };
};